<template>
    <el-dialog :title="dialogTitle" :visible="value" @update:visible="$emit('input', $event)" width="80%"
        :close-on-click-modal="false" @close="handleClose" top="80px" :modal-append-to-body="false" :modal="false">
        <div class="product-edit">
            <!-- 左侧导航 -->
            <div class="left-nav">
                <div class="product-image" @click="handleSelectMainImage">
                    <el-image :src="formData.image || defaultImage" fit="cover"></el-image>
                </div>
                <div class="nav-title">{{ formData.name || '名称' }}</div>
                <div class="nav-sku">{{ formData.sku || 'SKU' }}</div>
                <el-menu :default-active="activeTab" @select="handleSelect" class="nav-menu">
                    <el-menu-item v-for="item in menuItems" :key="item.index" :index="item.index">
                        {{ item.label }}
                    </el-menu-item>
                </el-menu>
            </div>
            <!-- 右侧内容区 -->
            <div class="right-content">
                <!-- 基本信息 -->
                <basic-info v-if="activeTab === 'basic'" :form-data="formData" :type="type" :category-list="categoryList" :brand-list="brandList" @update:formData="updateFormData" @saved="handleBasicInfoSaved" ref="basicInfo" :value="hasData" />

                <!-- 变体属性 -->
                <variant-attributes v-if="type === 'variant' && activeTab === 'variant'" :form-data="formData"
                    @update:formData="updateFormData" @back-to-basic="handleBackToBasic" />

                <!-- 平台信息 -->
                <platform-info v-if="activeTab === 'platform'" :form-data="formData"
                    @update:formData="updateFormData" />

                <!-- 供应商信息 -->
                <supplier-info v-if="type === 'single' && activeTab === 'supplier'" :form-data="formData"
                    @update:formData="updateFormData" />

                <!-- 物流信息 -->
                <logistics-info v-if="type === 'single' && activeTab === 'logistics'" :form-data="formData"
                    @update:formData="updateFormData" />

                <!-- 质检信息 -->
                <quality-info v-if="type === 'single' && activeTab === 'quality'" :form-data="formData"
                    @update:formData="updateFormData" />

                <!-- 图库 -->
                <gallery-info v-if="activeTab === 'gallery'" :form-data="formData" :selectSkuList="selectSkuList" @update:formData="updateFormData"
                    ref="galleryInfo" />

                <!-- Listing匹配 -->
                <listing-info v-if="type === 'single' && activeTab === 'listing'" :form-data="formData"
                    @update:formData="updateFormData" />
            </div>
        </div>
        <!-- 图片选择弹框 -->
        <el-dialog title="选择主图" :visible.sync="showImageDialog" width="80%" :modal-append-to-body="false">
            <div class="image-list">
                <div v-for="img in formData.mainImages" :key="img" class="image-item" @click="selectImage(img)">
                    <el-image :src="img" fit="cover" style="width: 160px; height: 160px;"></el-image>
                </div>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
import BasicInfo from './components/BasicInfo.vue'
import PlatformInfo from './components/PlatformInfo.vue'
import SupplierInfo from './components/SupplierInfo.vue'
import LogisticsInfo from './components/LogisticsInfo.vue'
import QualityInfo from './components/QualityInfo.vue'
import GalleryInfo from './components/GalleryInfo.vue'
import ListingInfo from './components/ListingInfo.vue'
import VariantAttributes from './components/VariantAttributes.vue'
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
    name: 'ProductEditDialog',
    components: {
        BasicInfo,
        PlatformInfo,
        SupplierInfo,
        LogisticsInfo,
        QualityInfo,
        GalleryInfo,
        ListingInfo,
        VariantAttributes
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'single',
            validator: value => ['single', 'variant'].includes(value)
        },
        productData: {
            type: Object,
            default: () => ({})
        },
        categoryList: {
            type: Array,
            default: () => []
        },
        brandList: {
            type: Array,
            default: () => []
        },
        selectSkuList:{
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            activeTab: 'basic',
            defaultImage: require('@/assets/imags/暂无图片.png'),
            formData: this.getInitialFormData(),
            fromListing: false,
            showImageDialog: false,
            hasData: false,
        }
    },
    computed: {
        dialogTitle() {
            return `编辑产品 (${this.type === 'single' ? '单体' : '变体'})`
        },
        menuItems() {
            const baseItems = [
                { index: 'basic', label: '基本信息' },
                { index: 'gallery', label: '图库' }
            ]
            if (this.type === 'variant') {
                return [
                    ...baseItems,
                    { index: 'variant', label: '变体' }
                ]
            } else {
                return [
                    ...baseItems,
                    { index: 'listing', label: 'Listing匹配' }
                ]
            }
        },
        userInfo(){
            return JSON.parse(localStorage.getItem('role'))
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.activeTab = 'basic'
                    // 如果是新建产品，重置表单数据
                    if (!this.productData || Object.keys(this.productData).length === 0) {
                        this.formData = this.getInitialFormData()
                        // 确保清空图库相关数据
                        this.$set(this.formData, 'images', '')
                        this.$set(this.formData, 'imagesJson', {
                            mainImages: [],
                            referenceImages: [],
                            sceneImages: [],
                            detailImages: []
                        })
                        // 清空图库组件数据
                        if (this.$refs.galleryInfo) {
                            this.$refs.galleryInfo.clearAllImages()
                        }
                        // 重置基本信息组件的表单
                        if (this.$refs.basicInfo && this.$refs.basicInfo.$refs.form) {
                            this.$refs.basicInfo.$refs.form.resetFields()
                        }
                    } else {
                        this.$nextTick(() => {
                            this.initFormData()
                        })
                    }
                }else{
                    this.hasData = false;
                }
            }
        },
        productData: {
            immediate: true,
            deep: true,
            handler(val) {
                // 只有在有productData且弹窗打开时才初始化数据
                if (val && Object.keys(val).length > 0 && this.value) {
                    this.$nextTick(() => {
                        this.initFormData()
                    })
                }
            }
        }
    },
    methods: {
        getInitialFormData() {
            return {
                name: '',
                sku: '',
                model: '',
                brand: '',
                status: '1',
                image: '',
                description: '',
                mainImages: [],
                variants: [],
                variantAttributes: [],
                imagesJson: {
                    mainImages: []
                }
            }
        },
        initFormData() {
            if (this.productData && Object.keys(this.productData).length > 0) {
                const newFormData = {
                    ...this.getInitialFormData(),
                    ...this.productData
                }
                Object.keys(newFormData).forEach(key => {
                    this.$set(this.formData, key, newFormData[key])
                })
                // 处理主图回显
                if (this.productData.imagesJson && this.productData.imagesJson.mainImages && this.productData.imagesJson.mainImages.length > 0) {
                    this.$set(this.formData, 'image', this.productData.imagesJson.mainImages[0])
                }
                this.hasData = true;
            }
            this.$forceUpdate()
        },
        handleSelect(key) {
            if ((key === 'listing' || key === 'variant') && !this.formData.id) {
                // 记录是从 listing 或 variant 页面跳转过来的
                this.fromListing = key === 'listing'
                // 切换到基本信息页面
                this.activeTab = 'basic'
                // 等待 DOM 更新后执行保存
                this.$nextTick(() => {
                    const basicInfoRef = this.$refs.basicInfo
                    if (basicInfoRef) {
                        basicInfoRef.handleSubmit()
                    }
                })
                return
            }
            this.activeTab = key
        },
        updateFormData(newData) {
            Object.keys(newData).forEach(key => {
                this.$set(this.formData, key, newData[key])
            })
        },
        handleCancel() {
            this.$emit('input', false)
            this.resetForm()
        },
        handleClose() {
            // 先切换到基本信息页面
            this.activeTab = 'basic';

            // 等待 DOM 更新后执行关闭操作
            this.$nextTick(() => {
                this.$emit('input', false);
                this.$emit('close');
                // 完全重置表单数据
                this.formData = this.getInitialFormData();
                // 确保清空图库相关数据
                this.$set(this.formData, 'images', '');
                this.$set(this.formData, 'imagesJson', {
                    mainImages: [],
                    referenceImages: [],
                    sceneImages: [],
                    detailImages: []
                });
                // 清空图库组件数据
                if (this.$refs.galleryInfo) {
                    this.$refs.galleryInfo.clearAllImages();
                }
                // 重置其他组件的数据
                if (this.$refs.basicInfo) {
                    this.$refs.basicInfo.$refs.form?.resetFields();
                }
            });
        },
        resetForm() {
            this.activeTab = 'basic'
            this.formData = this.getInitialFormData()
        },
        handleSelectMainImage() {
            if(this.activeTab !== 'gallery'){
                return
            }
            try {
                // 检查formData.images是否存在且不为空
                if (!this.formData.images) {
                    this.$message.warning('请先上传主图!')
                    return
                }

                // 尝试解析images数据
                let imagesData
                try {
                    imagesData = typeof this.formData.images === 'string' 
                        ? JSON.parse(this.formData.images) 
                        : this.formData.images
                } catch (e) {
                    console.error('解析图片数据失败:', e)
                    this.$message.error('图片数据格式错误')
                    return
                }

                // 验证mainImages数组是否存在且有数据
                if (!imagesData.mainImages || !Array.isArray(imagesData.mainImages) || imagesData.mainImages.length === 0) {
                    this.$message.warning('请先上传主图!')
                    return
                }

                this.formData.mainImages = imagesData.mainImages
                this.showImageDialog = true
            } catch (error) {
                console.error('选择主图时发生错误:', error)
                this.$message.error('选择主图失败，请重试')
            }
        },
        handleBasicInfoSaved(id) {
            this.$set(this.formData, 'id', id)
            if (this.activeTab === 'gallery' && this.$refs.galleryInfo) {
                this.$refs.galleryInfo.updateProductId(id)
            }
            // 如果是从 listing 或 variant 页面跳转过来的，保存成功后自动跳转回去
            if (this.fromListing) {
                this.fromListing = false
                this.activeTab = 'listing'
            } else if (this.activeTab === 'basic' && this.type === 'variant') {
                this.activeTab = 'variant'
            }
        },
        selectImage(img) {
            // 将选中的图片放在第一位，其他图片保持原有顺序
            const mainImages = [img, ...this.formData.mainImages.filter(image => image !== img)];
            this.$set(this.formData, 'mainImages', mainImages);
            this.$set(this.formData, 'image', img);
            this.showImageDialog = false;
            // 调用 GalleryInfo 的新方法更新主图顺序
            if (this.$refs.galleryInfo) {
                this.$refs.galleryInfo.updateMainImageOrder(this.formData.mainImages);
                this.$refs.galleryInfo.handleSubmit()
            }
        },
        handleBackToBasic() {
            // 切换到基本信息页面
            this.activeTab = 'basic'
            // 等待 DOM 更新后执行保存
            this.$nextTick(() => {
                const basicInfoRef = this.$refs.basicInfo
                if (basicInfoRef) {
                    basicInfoRef.handleSubmit()
                }
            })
        }
    }
}
</script>


<style lang="scss" scoped>
.product-edit {
    display: flex;
    height: 600px;
    overflow: auto;
    // height: 100%;
    // height: calc(90vh - 150px);
    background: #fff;

    .left-nav {
        width: 200px;
        border-right: 1px solid #EBEEF5;
        background: #f5f7fa;
        display: flex;
        flex-direction: column;
        height: 100%;

        .product-image {
            width: 120px;
            height: 120px;
            margin: 20px auto;
            flex-shrink: 0;
            border: 1px solid #DCDFE6;
            background: #fff;
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                border-color: #409EFF;
                box-shadow: 0 0 8px rgba(64, 158, 255, 0.2);
            }

            .el-image {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .nav-title {
            padding: 0 20px;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 5px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #303133;
            flex-shrink: 0;
        }

        .nav-sku {
            padding: 0 20px;
            color: #909399;
            margin-bottom: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex-shrink: 0;
        }

        .nav-menu {
            border-right: none;
            background: transparent;
            flex: 1;
            overflow-y: auto;

            .el-menu-item {
                height: 40px;
                line-height: 40px;
                color: #606266;
                font-size: 14px;
                padding: 0 20px;
                margin: 4px 0;

                &:hover {
                    background-color: #ecf5ff;
                    color: #409EFF;
                }

                &.is-active {
                    background-color: #fff;
                    color: #409EFF;
                    position: relative;

                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 0;
                        bottom: 0;
                        width: 3px;
                        background: #409EFF;
                    }
                }
            }
        }
    }

    .right-content {
        // flex: 1;
        width: calc(100% - 200px);
        padding: 20px;
        box-sizing: border-box;
        overflow-y: auto;
        background: #fff;
        height: 100%;
    }
}

.dialog-footer {
    text-align: right;
    padding: 15px 20px;
    border-top: 1px solid #EBEEF5;
    background: #fff;
}

.el-dialog {
    margin-top: 5vh !important;
    display: flex;
    flex-direction: column;
    max-height: 90vh;

    .el-dialog__body {
        padding: 0;
        flex: 1;
        overflow: hidden;
    }

    .el-dialog__header {
        padding: 15px 20px;
        border-bottom: 1px solid #EBEEF5;
        margin-right: 0;
    }
}

.image-list {
    display: flex;
    flex-wrap: nowrap;
    gap: 15px;
    padding: 10px;
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: hidden;
}
</style>